function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lisk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M138.16,0L108.88,48.7,214.58,229.84,128.83,326s67.4-.4,67,0S276,235.43,276,235.43ZM99.71,66.66L0,236.23,78.57,326h29.55l43.2-50.28h-48L61,228.65l67.8-115.31Z",
    style: {
      fill: "#04183d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLisk);
export default __webpack_public_path__ + "static/media/lisk.f7933153b21a7058364c1fe560acd3b7.svg";
export { ForwardRef as ReactComponent };